import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AbstractBaseDetailsComponent } from 'src/app/core/component/abstract-base-details-component';
import { SystemConfigSettingModel } from 'src/app/shared/model/system-config-setting-model';
import { CommonSelectListService } from 'src/app/shared/service/common-select-list.service';
import { SystemConfigService } from 'src/app/system-config/service/system-config.service';
import { environment } from 'src/environments/environment';
import { OrgProfileModal } from '../../org-profile/modal/org-profile-modal';
import { Organization } from '../../purchase-order/modal/organization';
import { SalesOrderModal } from '../modal/sales-order-modal';
import { SoDetailModal } from '../modal/so-detail-modal';
import { SalesOrderServiceService } from '../service/sales-order-service.service';
import { DomSanitizer } from '@angular/platform-browser';
import { UserModal } from '../../user/modal/user-modal';
import { ResponseCode } from '../../../core/constant/response-code';
import { lstat } from 'fs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DynamicParams, SOPrintModal } from '../sales-order-print/sales-order-print.component';

const amendedPoNo = 'amendedPoNo.';
const amendedPoDate = 'amendedPoDate';
const selectedDeliveryNote = 'selectedDeliveryNote';
const selectedDocumentNotes = 'selectedDocumentNotes';
const spiIns = 'spiIns';
const items = 'item';
const moduleName = 'SalesOrder';

@Component({
  selector: 'app-so-invoice-print',
  templateUrl: './so-invoice-print.component.html',
  styleUrls: ['./so-invoice-print.component.css']
})
export class SoInvoicePrintComponent extends AbstractBaseDetailsComponent implements OnInit {

  public organization: OrgProfileModal;

  @Input()
  public isHideHeaderFooter: boolean;

  @Input()
  public data: SalesOrderModal;

  public imgURL: string;

  @Input()
  public isWorkOrder: boolean;

  public modeOfTransport: string;

  public sysConfigModel: SystemConfigSettingModel = new SystemConfigSettingModel(this.systemConfigService);
  totalCost: number;
  totalAmountWithGST: number;
  totalDiscount: number;
  TotalFinalFrieghtAmount = 0;
  totalCGSTAmount = 0;
  totalSGSTAmount = 0;
  totalIGSTAmount = 0;
  TotalFinalAmount = 0;
  TotalAmount = 0;
  freightValue1 = 0;
  freightValue = 0;
  freightValue2 = 0;
  freightValue1Amount = 0;
  freightValue2Amount = 0;
  freightValueAmount = 0;
  FinalFreightAmount = 0;
  totalGSTAmount: number;
  totalgrandAmount: number = 0;
  public bank: Array<Organization>;
  subject: string;
  amendedPoNo: string;
  amendedPoDate: string;
  poDate: string;
  poReference: string;
  // selectedDeliveryNote: Array<DeliveryNote>;
  // deliveryNotes: Array<DeliveryNote>;
  // selectedDocumentNotes: Array<DeliveryNote>;
  // documentNotes: Array<DeliveryNote>;
  // splInstruction: Array<DeliveryNote>;
  paramArray = new Array<DynamicParams>();
  paramobj = new DynamicParams();
  spiIns: string;
  isDiagonal: boolean = false;
  isLifeoline: boolean = false;
  totalWeight: number;
  taxableTotal: number;
  isCgst: boolean = false;
  isIgst: boolean = false;
  printData: SOPrintModal;
  date = new Date();
  dataLocalUrl: any;
  paymentDays: number = 30;
  printby: UserModal;
  qrImgURL: string;
  signImg: string;
  public discountAmount = 0;
  public discountedAmount =0
  itemTupleIds = [];
  mode: string;
  duepayment:number;
  totalAvlStock: any = 0;
  @Input() public isUpdateComponent: boolean;
  @Output('onSave') onSave: EventEmitter<any> = new EventEmitter<any>();
  @Output('onCancel')
  public cancelCallback: EventEmitter<SoDetailModal> = new EventEmitter<SoDetailModal>();
  totalFrieght: number;
  FinalFrieghtAmount: any;
  totalproductionQty: number;
  pinumber: string;
  constructor(
    private systemConfigService: SystemConfigService,
    public toaster: ToastrService,
    public service: SalesOrderServiceService,
    public commonSerivce: CommonSelectListService,
    public ngbService: NgbModal,
    public SOService: SalesOrderServiceService
  ) {
    super(toaster);
    if (localStorage.getItem('activeUser')) {
      this.printby = JSON.parse(localStorage.getItem('activeUser'));
    }
  }

  ngOnInit() {

    console.log("data", this.data);
    this.getOrganization();
    if (this.data.grandTotal) {
      this.data.grandTotal = Number(this.data.grandTotal);
    }
    if (this.data.party.gstNumber) {
      this.data.stateCode = this.data.party.gstNumber.substring(0, 2);
    }
    this.isDiagonal = this.sysConfigModel.partnerKey == 'Diagonal';
    if (this.sysConfigModel.partnerKey == 'Alaska' && this.sysConfigModel.printPartner == 'Lifeoline') {
      this.isLifeoline = true;
    } else {
      this.isLifeoline = false;
    }

    // this.getById();
    // this.setData();
    setTimeout(() => {
      this.getTotal();
    }, 600)
    // // this.getTotal();
    // this.getDeliveryNotes();
    this.getOrganizationList();
    // this.getactiveuserDetails();

    // this.getByModuleNameId(this.data.id);
    if (this.data.soNumber) {
      let arr = [];
      arr = this.data.soNumber.split("-");
      arr[0] = "PI";
      this.pinumber = arr.join("-").toString();
      console.log("arr", arr);
      console.log("pinumber", this.pinumber);
    }
  }

  getOrganization() {
    this.commonSerivce.getOrganizationData().subscribe((res) => {
      this.organization = new OrgProfileModal();
      this.organization = res.data;
      console.log("gstin", this.organization.gstin);
      if (this.organization.qrCode) {
        this.qrImgURL = environment.DOWNLOAD_GET_FILE + this.organization.qrCode;
      }
    });
  }

  getOrganizationList() {
    this.service.getOrganizationList().subscribe((response) => {
      if (response.responseCode === ResponseCode.OK) {
        this.bank = new Array<Organization>();
        this.bank = response.dataList;
        this.getImageUrl();
      }
    });
  }

  getImageUrl() {
    if (this.bank[0]) {
      this.imgURL = environment.DOWNLOAD_GET_FILE + this.bank[0].headerLogo;
    }
  }

  getTotal() {
    console.log("SO", this.data);
    let req: any = {};
    if (this.data && this.data.party && this.data.party.gstNumber && this.organization && this.organization.gstin) {
      if (this.organization.gstin.slice(0, 2) === this.data.party.gstNumber.slice(0, 2)) {
        this.isCgst = true;
      } else {
        this.isIgst = true;
      }
    }

    this.totalCost = 0;
    this.totalAmountWithGST = 0;
    this.totalproductionQty = 0;
    this.totalDiscount = 0;
    this.totalGSTAmount = 0;
    this.totalWeight = 0;
    this.taxableTotal = 0;
    let stockList = new Array();

    if (this.data) {
      if (this.data.freightValue) {
        this.totalFrieght = (this.data.freight * this.data.freightValue.value) / 100;
        this.FinalFrieghtAmount = this.data.freight + this.totalFrieght;
      }
    }

    if (this.data.salesOrderItemDetails) {
      this.data.salesOrderItemDetails.forEach((res: any) => {
        res.price = parseFloat(res.price).toFixed(2);
        res.totalCost = res.price * res.weight;
        if(res.discount){
          res.discountAmount = (res.totalCost * res.discount)/100;
          res.discountedAmount = res.totalCost - res.discountAmount;
        } else {
          res.discount = 0;
          res.discountedAmount = res.totalCost;
        }

        this.discountedAmount += res.discountedAmount;


        if (this.isCgst && res.item.gst) {
          res.item.gst !== 0 ? res.cgst = res.item.gst / 2 : res.cgst = 0;
          res.item.gst !== 0 ? res.sgst = res.item.gst / 2 : res.sgst = 0;

          res.sgst != 0 ? res.sgstAmount = (res.discountedAmount * res.sgst) / 100 : 0;
          res.cgst != 0 ? res.cgstAmount = (res.discountedAmount * res.cgst) / 100 : 0;

         

          this.totalCGSTAmount += res.cgstAmount;
          this.totalSGSTAmount += res.sgstAmount;

          
          // res.finalAmt = Math.floor((res.sgstAmount + res.cgstAmount) + res.discountedAmount);
          // this.TotalFinalAmount += res.finalAmt;
          res.finalAmt = Math.floor(res.discountedAmount);
          this.TotalFinalAmount += Math.floor((res.sgstAmount + res.cgstAmount) + res.discountedAmount);
          this.TotalAmount += res.finalAmt;
          this.TotalFinalFrieghtAmount = this.TotalFinalAmount;


        } else if (this.isIgst && res.item.gst) {
          res.igst = res.item.gst;
          res.igst != 0 ? res.igstAmount = (res.discountedAmount * res.igst) / 100 : 0;
          if (this.data.freightValue) {

          }
          this.totalIGSTAmount += res.igstAmount;

          if (this.data.freightValue) {

          }
          res.finalAmt = Math.floor(res.discountedAmount);
          this.TotalFinalAmount = Math.floor(res.igstAmount + res.discountedAmount);
          this.TotalAmount += res.finalAmt;
          // res.finalAmt = Math.floor(res.igstAmount + res.discountedAmount);
          //this.TotalFinalAmount += res.finalAmt;
          this.TotalFinalFrieghtAmount = this.TotalFinalAmount;
        } else {
          res.cgst = 0;
          res.sgst = 0;
          res.igst = 0;
          res.cgstAmount = 0;
          res.sgstAmount = 0;
          res.igstAmount = 0;
          res.finalAmt = Math.floor(res.discountedAmount);
          this.TotalFinalAmount += res.finalAmt;
          this.TotalFinalFrieghtAmount = this.TotalFinalAmount;
        }

      });
    }

    if(this.data.freightValue){
      this.discountedAmount = Number(this.data.freight) + this.discountedAmount;

      if(this.isCgst){
        this.data.freightValue ? this.freightValue1 = this.data.freightValue.value / 2 : this.freightValue1 = 0;
        this.data.freightValue ? this.freightValue2 = this.data.freightValue.value / 2 : this.freightValue2 = 0;
        this.freightValue1 ? this.freightValue1Amount = (this.data.freight * this.freightValue1)/100:0;
        this.freightValue2 ? this.freightValue2Amount = (this.data.freight * this.freightValue2)/100:0;
        
        this.totalCGSTAmount = this.freightValue1Amount + this.totalCGSTAmount;
        this.totalSGSTAmount = this.freightValue2Amount + this.totalSGSTAmount;
        this.FinalFreightAmount = Number(this.data.freight) + (this.freightValue1Amount + this.freightValue2Amount);
        this.TotalFinalFrieghtAmount = this.FinalFreightAmount + this.TotalFinalAmount; 
      }

      if(this.isIgst){
        this.data.freightValue ? this.freightValue = this.data.freightValue.value : this.freightValue = 0;
        this.freightValue ? this.freightValueAmount = (this.data.freight * this.freightValue)/100:0;
        this.totalIGSTAmount = this.freightValueAmount + this.totalIGSTAmount;
        this.FinalFreightAmount = Number(this.data.freight) + this.freightValueAmount;
        this.TotalFinalFrieghtAmount = this.FinalFreightAmount + this.TotalFinalAmount;
        
      }
    }

    if(this.duepayment){
      this.totalgrandAmount = this.duepayment + this.TotalFinalFrieghtAmount;
      this.totalgrandAmount = Number(this.totalgrandAmount.toFixed(2));
    } else {
      this.totalgrandAmount = this.TotalFinalFrieghtAmount;
      this.totalgrandAmount = Number(this.totalgrandAmount.toFixed(2));
    }

  }

  onModalClose() {
    this.ngbService.dismissAll();
  }

  generatePrint(save?: boolean) {
    
  }

  onchangeduepayment(data){
    if(data){
      this.totalgrandAmount = Number(data) + this.TotalFinalFrieghtAmount;
      this.totalgrandAmount = Number(this.totalgrandAmount.toFixed(2));
    }
  }

}
